import React from "react";
import ManageChannelPage from "../manage-channel-page.jsx";

// @todo remove duplication from this component
export default function ChannelDetailsTab() {
  return <ManageChannelPage withoutBreadcrumbs={true} />;
}
